import { useTranslator, useDateFormatter } from '@bluebeam/react-i18n';
import OverlaySection from 'components/Overlays/OverlaySection';
import React from 'react';
import { getDateWithTimeStr } from 'utils/format';
import { useViewRfiMachine } from './ViewRFIMachine';

const ViewHistorySection: React.FC = () => {
  const { translate } = useTranslator(['mapView']);
  const dateFormatter = useDateFormatter({
    dateStyle: 'long',
    timeStyle: 'short',
  });
  const { viewRfiMachineState } = useViewRfiMachine();
  const { rfi } = viewRfiMachineState.context;
  const { answer } = rfi;

  // "Sent to Assignee" happens when it's created, and not a draft.
  // "Closed" is when the rfi has been answered.
  const closed = rfi.answer !== null;

  return (
    <OverlaySection label={translate('mapView:viewHistorySection.history')}>
      {closed ? (
        <div className="mb3">
          <div className="regular">
            {translate('mapView:viewHistorySection.closed')}
          </div>
          <div className="truncate">
            {dateFormatter?.format(
              new Date(getDateWithTimeStr(answer?.respondingdate || 0))
            )}
          </div>
          <div className="truncate">
            {answer && answer.reviewingname.length > 0
              ? answer?.reviewingname
              : answer?.reviewingemail}
          </div>
        </div>
      ) : null}
      <div>
        <div className="regular">
          {translate('mapView:viewHistorySection.sentToAssignee')}
        </div>
        <div className="truncate">
          {dateFormatter?.format(new Date(getDateWithTimeStr(rfi.craeteddate)))}
        </div>
        <div className="truncate">
          {rfi.submittingname.length > 0
            ? rfi.submittingname
            : rfi.submittingemail}
        </div>
      </div>
    </OverlaySection>
  );
};

export default ViewHistorySection;
